import { Box, Flex, Text } from '@mantine/core';

interface Props {
	color: string;
	value: number;
}

export const CountDot = ({ color, value }: Props) => (
	<Flex align="center" gap={4}>
		<Box w={6} h={6} style={{ borderRadius: '50%', backgroundColor: color }} />
		<Text size="sm" fw={600}>
			{value}
		</Text>
	</Flex>
);
